module.exports = __webpack_public_path__ + "img/emblem_1.697409ac.svg";